export const incomesQueryKey = 'incomes';
